// extracted by mini-css-extract-plugin
module.exports = {"modalPCertPassportError":"styles_modalPCertPassportError__2ZbOQ"};